import { render, staticRenderFns } from "./SettingsCategories.vue?vue&type=template&id=f47865cc"
import script from "./SettingsCategories.vue?vue&type=script&lang=js"
export * from "./SettingsCategories.vue?vue&type=script&lang=js"
import style0 from "./SettingsCategories.vue?vue&type=style&index=0&id=f47865cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports